import '../styles/pages/AboutMe.css'

export function AboutMe() {
    return (
        <div className="content">
            <h1 className="title">About Me</h1>
            <p id="aboutMeContent">
            <span className='highlight'>Software Engineer</span> with 4+ years of professional experience in full-stack and cloud-native development. 
            Skilled in designing and building high-performance, resilient, scalable systems across diverse domains, including AI and data-driven applications. 
            Dedicated to excelling in fast-paced, collaborative teams to deliver innovative, high-impact solutions.
            </p>
            <div className="about-actions">
                <a 
                    href="/Jason-Tedjosoesilo-Resume.pdf" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="resume-btn"
                >
                    View Resume
                </a>
            </div>
        </div>
    )
}